import { render, staticRenderFns } from "./CompanyReportingFilter.vue?vue&type=template&id=bf105bf8&scoped=true"
import script from "./CompanyReportingFilter.vue?vue&type=script&lang=js"
export * from "./CompanyReportingFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf105bf8",
  null
  
)

export default component.exports